
export default {
  name: "BaseHeader",
};
